<template>
    <ui-modal
        :name="$mx_getModalName"
        :load-success="loader.modalLoadSuccess"
        :load="loader.modalLoad"
        :title="'Duplicar Cliente - ' + id"
        icon="fal fa-copy"
        size="xs"
    >

        <div class="historical-area">
            <ui-text-with-select-area title="Tem certeza de que deseja duplicar o cliente?">
            </ui-text-with-select-area>
        </div>

        <template #footer>
            <div class="cancel-buttons">
                <ui-modal-cancel-button :modal-name="$mx_getModalName" :track-event="gtm.cancel"
                >Cancelar</ui-modal-cancel-button
                >
            </div>
            <ui-button
                type="button"
                design="md success mw-100"
                @click="submit"
            >Duplicar</ui-button
            >
        </template>
    </ui-modal>
</template>

<script>
	import { funnel } from '@/services/axios'

	import { uiModal, uiModalCancelButton } from '@/components/ui/modal'
	import { uiButton } from '@/components/ui/buttons'
	import { uiTextWithSelectArea } from '@/components/ui/form'

	import { loaderMixin, alertMixin, modalMixin, utilMixin } from '@/mixins'

	import { defaultGtm } from './default'
	import { facilita } from '@/global'


	const defaultLoader = {
		modalLoad: false,
		modalLoadSuccess: false,
		historicalTypesLoad: false,
	}

	export default {
		name: 'ui-duplicate-deal-modal',

		components: {
			uiModal,
			uiModalCancelButton,
			uiTextWithSelectArea,
			uiButton,
		},

		mixins: [loaderMixin, alertMixin, modalMixin, utilMixin],

		props: {
			name: {
				type: String,
				required: true,
			},
		},

		data() {
			return {
				id: null,
				loader: { ...defaultLoader },
				gtm: { ...defaultGtm() },
			}
		},

		mounted() {
			this.$root.$on('modal-open-' + this.$mx_getModalName, async (payload) => {
				this.id = payload.id
			})
		},

		beforeDestroy() {
			this.$mx_closeModal()
		},

		methods: {

			closeAnimation() {
				setTimeout(() => {
					this.$mx_setLoader('modalLoadSuccess', true)

					setTimeout(() => {
						this.$mx_closeModal()
						this.$mx_reloadTablePage()
					}, 1000)
				}, 500)
			},


			async submit() {
				this.$mx_setLoader('modalLoad', true)

				try {
					const response = await funnel.duplicateDeal(this.id)
					const duplicate = response.data.data
					const facilitaPanel = facilita.panel

					const link = `vendas/negocios/${duplicate.id}`
					this.$gtm.trackEvent(this.gtm.submit)
					window.open(facilitaPanel + link, '_self')
				} catch (error) {
					this.$toastr.e(error?.data?.msg || "Você não tem permissão para executar o recurso (funnel.deal.*.copie)." )
					this.$mx_setLoader('modalLoad', false)
				}
			},
		},
	}
</script>

<style lang="stylus" scoped>
	@import 'styles.styl'
</style>
